// eslint-disable-next-line max-len
var USER_INTERFACE_FAVORITE_STAR_OUTLINE = 'M32,12,21,11,16,0,11,11,0,12l8.3,8.37L6,32l10-6.07,10,6.07L23.69,20.37ZM17,24.22l-1-.64-1.05.64-6.07,3.7,1.41-7.16.21-1L9.72,19,4.41,13.61,11.18,13l1.16-.1.48-1.06,3.18-7,3.18,7,.48,1.06,1.16.1,6.76.62L22.27,19l-.75.75.2,1,1.39,7.2Z';

export { USER_INTERFACE_FAVORITE_STAR_OUTLINE };
//# sourceMappingURL=USER_INTERFACE_FAVORITE_STAR_OUTLINE.js.map
